module.exports = __webpack_public_path__ + "static/img/b4_footer.edae510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b4_footer.png
// module id = y6rO
// module chunks = 1